import immutable from 'immutable';
import { OPERATION_STATUS } from 'util/config/constant';
import * as actions from './action';

export const init = () => {
  const initValue = immutable.fromJS({
    data: undefined
  });

  return initValue.set('data', {
    status: OPERATION_STATUS.DEFAULT,
    isLoading: false
  });
};

export default function exportReducer(state = init(), action) {
  switch (action.type) {
    case actions.DATA_EXPORT_REQUEST:
      return state.set('data', {
        status: OPERATION_STATUS.DEFAULT,
        isLoading: true
      });

    case actions.DATA_EXPORT_SUCCESS: {
      return state.set('data', {
        status: OPERATION_STATUS.SUCCESS,
        isLoading: false
      });
    }

    case actions.DATA_EXPORT_FAIL:
      return state.set('data', {
        status: OPERATION_STATUS.FAIL,
        isLoading: false
      });

    case actions.RESET_DATA_EXPORT_STATE:
      return init();

    default:
      return state;
  }
}
